import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  setDoctors,
  setLoading,
  setError,
  createDoctor,
  updateDoctor,
  deleteDoctor,
  setDoctorById,
  setDoctorsAssociatedWithStore,
  unlinkDoctor,
  setDoctorsNotAssigned,
  updateDoctorStatus,
  setDoctorDetail,
  setBillingDetail,
  setRentDetails,
  setDoctorRecord,
  setDoctorReport,
  setOnboardingRequests,
  updateOnboardingRequestInSlice,
} from "../../Reducer/Doctor/DoctorSlice";
import apiAxios from "../../../services/apiAxios";
import toast from "react-hot-toast";

export const fetchDoctors = createAsyncThunk(
  "doctor/fetchDoctors",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/doctor");
      dispatch(setDoctors(response?.data));
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const updateAutoSignature = createAsyncThunk(
  "doctor/updateAutoSignature",
  async ({doctorId, formData}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const { data } = await apiAxios.post(`api/doctor/${doctorId}`, formData);
      toast.success(data?.message);
      dispatch(getDoctorDetails());
    } catch (error) {
      toast.error(error.toString());
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const deleteAutoSignature = createAsyncThunk(
  "doctor/deleteAutoSignature",
  async ({doctorId}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const { data } = await apiAxios.delete(`api/doctor/signature/${doctorId}`);
      toast.success(data?.message);
      dispatch(setLoading(false));
      dispatch(getDoctorDetails());
    } catch (error) {
      toast.error(error.toString());
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const deleteDoctorLogo = createAsyncThunk(
  "doctor/deleteDoctorLogo",
  async ({doctorId}, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const { data } = await apiAxios.delete(`api/doctor/logo/${doctorId}`);
      toast.success(data?.message);
      dispatch(setLoading(false));
      dispatch(getDoctorDetails());
    } catch (error) {
      toast.error(error.toString());
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const fetchDoctorById = createAsyncThunk(
  "doctor/fetchDoctorById",
  async (doctorId, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`api/doctor/${doctorId?.doctorId}`);
      dispatch(setDoctorById(response?.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const addDoctor = createAsyncThunk(
  "doctor/addDoctor",
  async (doctor, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("/api/doctor", doctor);
      if (response.status === 200 || response.status === 201) {
        dispatch(createDoctor(response?.data));
        dispatch(setLoading(false));
        toast.success("Doctor successfully created");
      } else {
        dispatch(setLoading(false));
        // toast.error(response?.message);
      }
      return response;
    } catch (error) {
      // toast.error("Something Went Wrong!!");
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const modifyDoctor = createAsyncThunk(
  "doctor/modifyDoctor",
  async ({ id, updatedData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.put(`/api/doctor/${id}`, updatedData);
      if (response?.status === 200) {
        toast.success("Successfully update doctor.");
        dispatch(updateDoctor({ id, updatedData: response?.data }));
        dispatch(setLoading(false));
        return response;
        // const idPayload = {doctorId: id}
        // dispatch(fetchDoctorById(idPayload))
        // dispatch(fetchDoctors());
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const removeDoctor = createAsyncThunk(
  "doctor/removeDoctor",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(`api/doctor/${id}`);
      if (response?.status === 200) {
        toast.success("Doctor removed successfully");
        dispatch(deleteDoctor(id));
        dispatch(setDoctorById({}));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
    }
  }
);

export const getAllDoctorsOfStore = createAsyncThunk(
  "doctor/getAllDoctorsOfStore",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`api/store/get-doctors/${id}`);
      if (response?.status === 200) {
        dispatch(setDoctorsAssociatedWithStore(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const getDoctorsNotAssigned = createAsyncThunk(
  "doctor/getDoctorsNotAssigned",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(`api/store/get-doctors`);
      if (response?.status === 200) {
        dispatch(setDoctorsNotAssigned(response?.data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const UnlinkDoctorFromStore = createAsyncThunk(
  "doctor/UnlinkDoctorFromStore",
  async (ids, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.delete(
        `api/store/remove-doctor/${ids.id}/store/${ids.sid}`
      );
      if (response) toast.success("Doctor removed successfully");
      dispatch(unlinkDoctor(ids.id));
      dispatch(getDoctorsNotAssigned());
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.toString()));
      dispatch(setLoading(false));
    }
  }
);

export const updateStatus = createAsyncThunk(
  "store/updateStatus",
  async (status, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.patch(
        `api/doctor/update-doctor-status`,
        status
      );
      if (response?.status === 200) {
        dispatch(setLoading(false));
        dispatch(updateDoctorStatus({ newStatus: status.currentDoctorStatus }));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
    }
  }
);

export const getDoctorDetails = createAsyncThunk(
  "store/getDoctorDetails",
  async (token, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/doctor/get-doctor-detail");
      dispatch(setDoctorDetail(response?.data));
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        // dispatch(fetchFrequentProducts(response?.data?.doctor?.DID));
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
    }
  }
);

export const getBillingDetails = createAsyncThunk(
  "store/getBillingDetails",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/doctor/get-billing-detail");
      dispatch(setBillingDetail(response?.data));
      dispatch(setLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const getRent = createAsyncThunk(
  "doctor/getRent",
  async ({ id, year, month }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`/api/rent/get/${id}`, {
        year,
        month,
      });
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        dispatch(setRentDetails(response.data));
      } else {
        dispatch(setLoading(false));
        toast.error(response?.message);
      }
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const updateRecord = createAsyncThunk(
  "doctor/updateRecord",
  async ({ id, payload }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.put(
        `/api/auth/update/publish-record/${id}`,

        payload
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        // dispatch(setRentDetails(response.data));
      } else {
        dispatch(setLoading(false));
        // toast.error("Something went wrong.");
      }
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const publishRecord = createAsyncThunk(
  "doctor/getRent",
  async (data, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`/api/auth/publish-record`, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(setLoading(false));
        // dispatch(setDoctorRecord(response.data));
      } else {
        // toast.error("Something went wrong.");
      }
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const getDoctorRecords = createAsyncThunk(
  "store/getDoctorRecords",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("/api/auth/get-all-publish-record");
      dispatch(setDoctorRecord(response?.data));
      dispatch(setLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);
export const getDoctorRecord = createAsyncThunk(
  "store/getDoctorRecord",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get(
        `/api/doctor/get-publish-record/${id}`
      );
      dispatch(setDoctorRecord(response?.data));
      dispatch(setLoading(false));
      return response?.data;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const getDoctorReport = createAsyncThunk(
  "store/getDoctorReport",
  async ({ id, year, month, page, limit }, { dispatch }) => {
    // dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(
        `/api/rent/get-orders/${id}?page=${page}&limit=${limit}`,
        {
          year,
          month,
        }
      );
      dispatch(setDoctorReport(response?.data));
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

export const downloadDoctorReportList = createAsyncThunk(
  "store/downloadDoctorReportList",
  async ({ id, year, month }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`/api/rent/create-csv/${id}`, {
        year,
        month,
      });
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      return error;
    }
  }
);

// Doctor Account Onboarding requests thunks
export const submitOnboardingRequest = createAsyncThunk(
  "doctor/submitOnboardingRequest",
  async (requestData, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post("api/doctor/onboard", requestData);
      dispatch(setLoading(false));
      toast.success("Onboarding request submitted successfully!");
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      const errMsg = error.response?.data?.error || error.message || error.toString();
      toast.error(errMsg);
      dispatch(setError(errMsg));
      throw error;
    }
  }
);

export const fetchOnboardingRequests = createAsyncThunk(
  "doctor/fetchOnboardingRequests",
  async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.get("api/doctor/onboarding-requests");
      dispatch(setOnboardingRequests(response?.data || []));
      dispatch(setLoading(false));
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(setError(error.toString()));
      toast.error("Failed to load onboarding requests");
      throw error;
    }
  }
);

export const updateOnboardingRequest = createAsyncThunk(
  "doctor/updateOnboardingRequest",
  async ({ id, updatedData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.put(`api/doctor/onboarding-requests/${id}`, updatedData);
      dispatch(updateOnboardingRequestInSlice(response?.data));
      dispatch(setLoading(false));
      toast.success("Request updated successfully");
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      const errMsg = error.response?.data?.error || error.message || error.toString();
      toast.error(errMsg);
      dispatch(setError(errMsg));
      throw error;
    }
  }
);

export const registerDoctorRequest = createAsyncThunk(
  "doctor/registerDoctorRequest",
  async ({ id, finalData }, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/doctor/onboarding-requests/${id}/register`, finalData);
      dispatch(setLoading(false));
      toast.success("Doctor registered successfully!");
      dispatch(fetchOnboardingRequests());
      dispatch(fetchDoctors());
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      const errMsg = error.response?.data?.error || error.message || error.toString();
      toast.error(errMsg);
      dispatch(setError(errMsg));
      throw error;
    }
  }
);

export const sendOnboardingCredentials = createAsyncThunk(
  "doctor/sendOnboardingCredentials",
  async (id, { dispatch }) => {
    dispatch(setLoading(true));
    try {
      const response = await apiAxios.post(`api/doctor/onboarding-requests/${id}/send-credentials`);
      dispatch(setLoading(false));
      toast.success("Credentials sent on WhatsApp successfully!");
      return response.data;
    } catch (error) {
      dispatch(setLoading(false));
      const errMsg = error.response?.data?.error || error.message || error.toString();
      toast.error(errMsg);
      dispatch(setError(errMsg));
      throw error;
    }
  }
);
